import { render, staticRenderFns } from "./ServiceOld.vue?vue&type=template&id=2498f2b8&scoped=true&"
import script from "./ServiceOld.vue?vue&type=script&lang=js&"
export * from "./ServiceOld.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOld.vue?vue&type=style&index=0&id=2498f2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498f2b8",
  null
  
)

export default component.exports